<template>
  <div class="page" :style="getBg()">
    <Header title="扫码签到预注册" :show-back="true" />
    <div class="subject">{{ activityInfo.activityName }}</div>
    <!-- <div class="activity-img">
      <img :src="activityInfo.activityImageId ? this.getImageUrl(this.activityInfo.activityImageUri) : defaultImg">
    </div> -->
    <div class="content">
      <div>
        <van-row class="clinet-type">
          <van-col offset="1" span="6">公司类型：</van-col>
          <van-col span="16">
            <van-radio-group v-model="regData.clientType">
              <van-radio name="02" checked-color="#117281">贸易商</van-radio>
              <van-radio name="03" checked-color="#117281">修理厂</van-radio>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-field v-model="regData.clientName" center clearable placeholder="请输入公司名称" @blur="viewDefault" />
        <van-field v-model="regData.contactPerson" center clearable placeholder="请输入联系人姓名" @blur="viewDefault" />
        <van-field v-model="regData.contactMobile" center clearable placeholder="请输入联系人手机" @blur="viewDefault" />
      </div>
      <div class="button-line" @click="submitData">提交预注册信息</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
export default {
  name: 'ActivityQrSign',
  components: {
    Header
  },
  data () {
    return {
      activityInfo: {},
      regData: {
        activityId: '',
        clientType: '',
        clientName: '',
        contactPerson: '',
        contactMobile: '',
        bgHeight: ''
      },
      defaultImg: require('../../assets/images/activity-default.png')
    }
  },
  computed: {
  },
  created () {
    this.init()
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,
    parseTime: commonUtils.parseTime,
    init () {
      this.regData.activityId = this.$route.params.activityId
      this.queryActivityInfo()
      this.bgHeight = (document.body.scrollHeight || document.documentElement.scrollHeight) - 46
    },
    queryActivityInfo () {
      this.$store.dispatch('getQrActivityInfo', this.regData.activityId).then(response => {
        this.activityInfo = response
      })
    },
    submitData () {
      const startDate = new Date(this.activityInfo.startDate)
      const endDate = new Date(this.activityInfo.endDate)
      const currentDate = new Date()
      if (currentDate > endDate) {
        this.$dialog.alert({ message: '活动已过期' })
        return false
      }
      if (currentDate < startDate) {
        this.$dialog.alert({ message: '活动于' + this.parseTime(this.activityInfo.startDate, '{y}/{m}/{d}') + '开始' })
        return false
      }
      if (!this.regData.clientType) {
        this.$dialog.alert({ message: '请选择公司类型' })
        return false
      }
      if (!this.regData.clientName) {
        this.$dialog.alert({ message: '请填写公司名称' })
        return false
      }
      if (!this.regData.contactPerson) {
        this.$dialog.alert({ message: '请填写联系人姓名' })
        return false
      }
      if (!this.regData.contactMobile) {
        this.$dialog.alert({ message: '请填写联系人手机' })
        return false
      }
      if (this.regData.contactMobile && !(/^1[3456789]\d{9}$/.test(this.regData.contactMobile))) {
        this.$dialog.alert({ message: '手机号格式有误' })
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '提交验证...'
      })
      activityApi.registeQrActivity(this.regData).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.$dialog.alert({
            title: '预注册成功',
            message: '恭喜您获得' + this.activityInfo.pointValue + this.activityInfo.pointTypeName + '，请尽快到易加网首页注册，注册成功后，积分生效。点击确定返回易加网首页',
            confirmButtonText: '确定'
          }).then(() => {
            window.location.href = commonUtils.getExtraSite()
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    getBg () {
      if (this.activityInfo.activityImageId) {
        return {
          background: '#fff url(' + this.getImageUrl(this.activityInfo.activityImageUri) + ') no-repeat 0 40px',
          backgroundSize: 'cover',
          height: this.bgHeight + 'px'
        }
      }
      return {
        background: '#fff url(' + require('../../assets/images/activity-default.png') + ') no-repeat 0 40px',
        backgroundSize: 'contain',
        height: this.bgHeight + 'px'
      }
    },
    viewDefault () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100% - 46px);
  background: #fff;
}
.subject {
  text-align: center;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;
  color: rgb(249, 127, 127);
  padding: 25px 0 15px;
}
.activity-img {
  width: 100%;
  height: 180px;
  margin-bottom: 15px;
  overflow: hidden;
  img {
    width: 100%;
    height: 180px;
  }
}
.content {
  width: 80%;
  margin: 0 auto;
  /deep/ .van-radio__label {
    color: rgb(183, 202, 206);
  }
  /deep/ .van-radio__icon--checked + .van-radio__label {
    color: #333;
  }
  .van-cell {
    height: 40px;
    border: 1px solid rgb(183, 202, 206);
    border-radius: 10px;
    margin-bottom: 15px;
  }
  ::-webkit-input-placeholder{
    color: rgb(183, 202, 206);
  }
}
.clinet-type {
  display: flex;
  align-items: center;
  padding: 0 0 15px;
  .van-radio-group {
    display: flex;
  }
  .van-radio {
    align-items: center;
    width: 50%;
  }
  /deep/ .van-radio__icon {
    width: 22px;
    height: 22px;
  }
}
.button-line {
  height: 40px;
  border-radius: 10px;
  margin: 25px 0 15px;
  background: rgb(52, 122, 127);
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
}
</style>
